import _axios from '@/utils/request'

// 视频列表
export function postVideoList (params) {
    return _axios('post', `/ms-hoc-video/v1/video/list`, params)
}

// 上传视频
export function postVideoUpload (params) {
    return _axios('post', `/ms-hoc-video/v2/video/upload`, params)
}

// 删除视频
export function deleteVideo (videoId) {
    return _axios('delete', `/ms-hoc-video/v1/video/${videoId}`)
}

// 生成链接
export function createVideoLink (videoId) {
    return _axios('post', `/ms-hoc-video/v1/video/tempUrl/${videoId}`)
}

// 通过key获取视频
export function getVideoLink (key) {
    return _axios('get', `/ms-hoc-video/v1/video/getVideoIdFromKey/${key}`)
}
